export default __webpack_public_path__ + "static/media/1.68be97df.jpg";